import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Button from './buttons/baseButton';
import InformationText from './InformationText';
import customIcons from '../utils/icons';

interface AdvancedModalProps {
  isOpen: boolean;
  headerIcon: React.ReactNode;
  headerText: { title: string, subtitle: string };
  children?: React.ReactNode;
  actionButton: { label: string, class: string, function: () => void; };
  onClose: () => void;
}

export default function AdvancedModal(props: AdvancedModalProps) {
  const {
    actionButton, onClose, isOpen, children, headerText, headerIcon,
  } = props;
  const modalRoot = document.body;

  const modalRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement) {
      if (isOpen) {
        modalElement.showModal();
      } else {
        modalElement.close();
      }
    }
  }, [isOpen]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDialogElement>) => {
    if (event.key === 'Escape') {
      onClose();
    }
  };
  if (!isOpen) {
    return null;
  }
  return ReactDOM.createPortal(
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <dialog
      id="advanced-modal"
      ref={modalRef}
      onKeyDown={handleKeyDown}
      className="modal-container"
    >
      <div id="modal-header" className="flex items-center text-start gap-2 w-full">
        <i className="m-4 text-2xl text-primary">{headerIcon}</i>
        <InformationText title={headerText.title} subtitle={headerText.subtitle} />
      </div>
      <div id="modal-content" className="w-full overflow-y-scroll">
        {children}
      </div>
      <div className="flex justify-evenly items-center w-full">
        <Button
          id="cancel-modal-button"
          label="Cancel"
          className="p-1 m-4 button-default w-full"
          onClick={onClose}
        />
        <Button
          id={`${actionButton.label}-modal-button`}
          label={actionButton.label}
          className={`p-1 m-4 w-full ${actionButton.class}`}
          onClick={actionButton.function}
        />
        <Button
          id="close-filter-modal"
          icon={customIcons.closeIcon}
          label=""
          className="absolute top-0 right-0 p-1 m-4 bg-white"
          onClick={onClose}
        />
      </div>
    </dialog>,
    modalRoot,
  );
}
